import { Tooltip as TooltipOriginal, type TooltipProps } from 'antd';
import { CircleQuestionMark } from 'lucide-react';

// The project tooltip (ratchet WI8). Without children it renders a help icon as the trigger.
export function Tooltip({ children, ...props }: TooltipProps) {
    return (
        <TooltipOriginal {...props}>
            {children ?? <CircleQuestionMark className="size-4 cursor-help text-subtle-foreground" />}
        </TooltipOriginal>
    );
}
